import React from "react"
import PropTypes from "prop-types"

class Header extends React.Component {
  render () {
    return (
      <React.Fragment>
        <header>
          <div className="container">
            <div className="header-content">

              <h1>
                {this.props.header_title}
              </h1>
              
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  header_title: PropTypes.string
};
export default Header
